<template>
  <div>
    <!-- 시나리오 목록 -->
    <c-table
      ref="table"
      title="LBL0001165"
      :columns="grid.columns"
      :gridHeight="grid.height"
      :data="grid.data"
      :merge="grid.merge"
      :filtering="false"
      :columnSetting="false"
      :usePaging="false"
      :editable="false"
    >
      <template v-slot:customArea="{ props, col }">
        <template v-if="col.name === 'riskHazardPicture'">
          <q-btn
            unelevated
            round
            dense
            size="7px"
            color="primary"
            icon="wallpaper"
            @click.stop="openHazardPicture(props)"
          />
        </template>
        <template v-else-if="col.name === 'picture'">
          <q-btn
            unelevated
            round
            dense
            size="7px"
            color="primary"
            icon="wallpaper"
            @click.stop="openImprPicture(props)"
          />
        </template>
        <template v-else-if="col.name === 'customCol'">
          <component
            :is="imprComponent"
            :col="col"
            :props="props"
            :inputEditable="false"
            :requestContentsCols="requestContentsCols"
            tableKey="ram4mAssessScenarioId"
            ibmTaskTypeCd="ITT0000023"
            ibmTaskUnderTypeCd="ITTU000030"
            @imprChange="imprChange"
          />
        </template>
      </template>
    </c-table>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
import selectConfig from "@/js/selectConfig";
export default {
  name: "fm-scenario-TL",
  props: {
    param: {
      type: Object,
      default: () => ({
        ramRiskAssessmentPlanId: "",
        ramStepCd: "",
        vendorFlag: false,
      }),
    },
  },
  data() {
    return {
      editable: true,
      grid: {
        merge: [
          { index: 0, colName: "processName" },
          { index: 1, colName: "groupMdmSopId" },
          { index: 2, colName: "ram4mRiskHazardClassGroup" },
        ],
        columns: [
          {
            fix: true,
            name: "processName",
            field: "processName",
            // 공정
            label: "공정",
            align: "center",
            style: "width:100px",
            sortable: false,
          },
          {
            fix: true,
            name: "jobName",
            field: "jobName",
            // 작업
            label: "단위작업(순서)",
            align: "left",
            style: "width:150px",
            sortable: false,
          },
          {
            fix: true,
            name: "ram4mRiskHazardClassName",
            field: "ram4mRiskHazardClassName",
            // 평가구분(4M)
            label: "LBL0001112",
            align: "center",
            style: "width:90px",
            sortable: false,
          },
          // {
          //   fix: true,
          //   name: 'riskHazardPicture',
          //   field: 'riskHazardPicture',
          //   // 사진
          //   label: 'LBL0001175',
          //   align: 'center',
          //   style: 'width:40px',
          //   sortable: false,
          //   type: 'custom',
          // },
          {
            fix: true,
            name: "riskHazardName",
            field: "riskHazardName",
            // 유해위험요인
            label: "LBL0001050",
            align: "left",
            style: "width:170px",
            sortable: false,
          },
          // {
          //   name: 'relationLaw',
          //   field: 'relationLaw',
          //   // 관련법규
          //   label: 'LBL0001021',
          //   align: 'left',
          //   style: 'width:120px',
          //   sortable: false,
          // },
          // {
          //   name: 'damageTargetName',
          //   field: 'damageTargetName',
          //   // 피해대상
          //   label: 'LBL0001185',
          //   align: 'left',
          //   style: 'width:120px',
          //   sortable: false,
          // },
          {
            name: "damageTypeNameName",
            field: "damageTypeNameName",
            // 재해형태
            label: "LBL0001186",
            align: "left",
            style: "width:120px",
            sortable: false,
          },
          {
            name: "existingRiskManagementActivities",
            field: "existingRiskManagementActivities",
            label: "현재안전조치<br/>현재관리방법",
            align: "left",
            style: "width:180px",
            sortable: false,
          },
          {
            name: "before",
            field: "before",
            label: "현재위험도",
            align: "center",
            child: [
              {
                name: "beforeFrequency",
                field: "beforeFrequency",
                // 빈도
                label: "LBL0001009",
                align: "center",
                style: "width:50px",
                sortable: false,
              },
              {
                name: "beforeStrength",
                field: "beforeStrength",
                // 강도
                label: "LBL0001010",
                align: "center",
                style: "width:50px",
                sortable: false,
              },
              {
                name: "beforeRisk",
                field: "beforeRisk",
                // 위험도
                label: "LBL0001011",
                align: "center",
                style: "width:70px",
                sortable: false,
              },
            ],
          },
          // {
          //   name: 'picture',
          //   field: 'picture',
          //   // 개선<br/>전/후<br/>사진
          //   label: 'LBL0001176',
          //   align: 'center',
          //   type: 'custom',
          //   style: 'width:70px',
          //   sortable: false,
          // },
          {
            name: "addingRiskManagementActivities",
            field: "addingRiskManagementActivities",
            // 추가 리스크관리 계획
            label: "개선방향(대책)",
            align: "left",
            style: "width:180px",
            sortable: false,
          },
          {
            name: "improveFlagName",
            field: "improveFlagName",
            label: "개선진행여부",
            align: "center",
            style: "width:100px",
            sortable: false,
          },
          {
            name: "after",
            field: "after",
            label: "개선후 위험도",
            align: "center",
            child: [
              {
                name: "afterFrequency",
                field: "afterFrequency",
                // 빈도
                label: "LBL0001009",
                align: "center",
                style: "width:50px",
                sortable: false,
              },
              {
                name: "afterStrength",
                field: "afterStrength",
                // 강도
                label: "LBL0001010",
                align: "center",
                style: "width:50px",
                sortable: false,
              },
              {
                name: "afterRisk",
                field: "afterRisk",
                // 위험도
                label: "LBL0001011",
                align: "center",
                style: "width:70px",
                sortable: false,
              },
            ],
          },
          {
            name: "assessDate",
            field: "assessDate",
            // 평가일
            label: "LBL0001013",
            align: "center",
            style: "width:90px",
            sortable: false,
          },
          {
            name: "assessUserName",
            field: "assessUserName",
            // 평가자
            label: "LBL0001014",
            align: "center",
            userId: "assessUserId",
            style: "width:80px",
            sortable: false,
          },
        ],
        data: [],
        height: "600px",
      },
      requestImprRow: null,
      imprData: null,
      colorItems: [],
      listUrl: "",
      popupOptions: {
        target: null,
        title: "",
        visible: false,
        width: "80%",
        param: {},
        closeCallback: null,
      },
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {},
  computed: {
    imprComponent() {
      let components = null;
      if (!this.param.vendorFlag) {
        components = () => import(`${"@/pages/common/ibm/tableImpr.vue"}`);
      } else {
        components = () => import(`${"@/pages/ram/4m/4mTableImpr.vue"}`);
      }
      return components;
    },
    requestContentsCols() {
      return ["jobName", "ram4mRiskHazardClassName", "riskHazardName"];
    },
  },
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // url setting
      this.listUrl = selectConfig.ram.fm.scenario.list.url;
      // code setting
      // this.$comm.getStepItems('IBM_STEP_CD').then(_result => {
      //   this.colorItems = _result
      // });
      // list setting
      this.getList();
    },
    getList() {
      this.$http.url = this.listUrl;
      this.$http.type = "GET";
      this.$http.param = {
        ramRiskAssessmentPlanId: this.param.ramRiskAssessmentPlanId,
      };
      this.$http.request((_result) => {
        this.grid.data = _result.data;
      });
    },
    /* eslint-disable no-unused-vars */
    imprChange(data) {
      this.$refs["table"].$refs["compo-table"].resetVirtualScroll();
    },
    openHazardPicture(props) {
      this.popupOptions.title = "LBL0001110"; // 유해위험요인 사진
      this.popupOptions.param = {
        ram4mAssessScenarioId: props.row.ram4mAssessScenarioId,
        disabled: true,
      };
      this.popupOptions.target = () =>
        import(`${"@/pages/common/hazard/riskHazardPicture.vue"}`);
      this.popupOptions.width = "30%";
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closeHazardPicturePopup;
    },
    closeHazardPicturePopup() {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
    },
    openImprPicture(props) {
      this.popupOptions.title = "LBL0001181"; // 개선 사진
      this.popupOptions.param = {
        ram4mAssessScenarioId: props.row.ram4mAssessScenarioId,
        sopImprovementIds: props.row.sopImprovementIds,
        ram4mAssessImprIds: props.row.ram4mAssessImprIds,
        disabled: true,
      };
      this.popupOptions.target = () =>
        import(`${"@/pages/ram/4m/action/4mScenarioImprPicture.vue"}`);
      this.popupOptions.width = "30%";
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closeScenarioImprPicturePopup;
    },
    closeScenarioImprPicturePopup() {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
    },
  },
};
</script>
